//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { add, assign, cloneDeep } from '~/assets/js/utils.js'
export default {
  async asyncData ({ $api }) {
    try {
      const { typeList = [], eaList = [] } = await $api.holdPosi.eaListServer()
      const text = typeList[0]?.type || ''
      return {
        tabsList: (typeList || []),
        completeList: (eaList || []),
        text
      }
    } catch (err) {}
  },
  data () {
    return {
      currTab: '0', // 当前tab选中项
      tabsList: [], // tab栏
      completeList: [], // 列表项全部数据（接口返回）
      eaList: [], // 列表项
      downShow: false, // 是否展示下拉框（移动端）
      text: '' // 下拉框选中项文本（移动端）
    }
  },
  head () {
    return {
      title: this.$t('19812'),
      meta: [
        { name: 'Keywords', content: this.$t('TYY_000097') },
        { name: 'Description', content: this.$t('19813') }
      ]
    }
  },
  created () {
    this.eaList = this.dealData(cloneDeep(this.completeList))
  },
  methods: {
    // tab点击事件
    tabFn (obj = {}) {
      const { typeId: value = '0', type: text = '' } = obj
      this.currTab = value
      this.text = text
      const origion = cloneDeep(this.completeList)
      this.eaList = value > 0 ? (origion?.filter(item => item.typeId == value) || []) : origion
      const closeTimer = setTimeout(() => {
        clearTimeout(closeTimer)
        this.parentFn()
      }, 0)
    },
    // 点赞
    async praiseFn (obj = {}) {
      const { GoodsId = '', dot = 0, isPraise = false } = obj
      if (isPraise) return true // 已点赞，不执行后续操作
      assign(obj, { dot: add(dot, 1), isPraise: true })
      await this.$api.holdPosi.eaPraise({ GoodsId })
    },
    // 跳转至详情页
    toDetails (value = '') {
      window?.open(`/${this.currLangCode()}/eashop/${value}.html`)
    },
    // 处理接口返回的数据
    dealData (arr = []) {
      arr?.forEach((item) => {
        item.isPraise = false
        item.profit_rate = (item.profit_rate || 0)
        item.purchaseQuantify = (item.purchaseQuantify || 0)
        item.dot = (item.dot || 0)
      })
      return arr
    },
    // 最外面盒子的点击事件
    parentFn () {
      this.downShow = false
    }
  }
}
